import { ReactElement } from 'react';
import { Field, ErrorMessage } from 'formik';
import classNames from 'classnames';

interface SelectFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  options: string[];
  required?: boolean;
  labeled?: boolean;
  className?: string;
}

const SelectField = ({
  name,
  label,
  placeholder = '-- Seleccionar --',
  options,
  required = false,
  labeled = false,
  className = '',
}: SelectFieldProps): ReactElement => {
  return (
    <div className={classNames('flex flex-col w-full mb-4', className)}>
      {labeled && label && (
        <label htmlFor={name} className="mb-2 text-sm font-medium">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Field name={name}>
        {({ field, meta }: any) => (
          <select
            {...field}
            id={name}
            className={classNames(
              'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-copper focus:border-transparent',
              {
                'border-red-500': meta.touched && meta.error,
                'border-gray-300': !meta.touched || !meta.error,
              }
            )}
            required={required}
          >
            <option value="">{placeholder}</option>
            {options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-xs mt-1"
      />
    </div>
  );
};

export default SelectField;